import React from "react";
import { PanelCard } from "../../../components";
import localData from "../../../localData";

export default function Experience() {
    const {  work } = localData.svgs;
    const { experience } = localData.images;

    const experiences = [
        {
            date: "january 2019 - june 2019",
            title: "interface managment",
            description:
                "assisted in building beautiful interfaces for clients without compromising functionality for aesthetics.",
            icon: work,
        },
        {
            date: "february 2020 - april 2020",
            title: "OOP programming",
            description: "learned front-end object-oriented programming to develop client-server systems.",
            icon: work,
        },
        {
            date: 'september 2020 - june 2021',
            title: "react components",
            description:
                "built 20 interactive, single-page React apps that could scale with both increase in interaction complexity and volume",
            icon: work,
        },
    ];

    return (
        <section className="experience" id='experience' data-lazy-block>
            <div className="container">
                <h2 className="experience-title" data-lazy='fade'>experience</h2>
                <div className="experience-center">
                    <div className="card-group card-group-experience">
                        {experiences.map((experience, index) => {
                            return <PanelCard key={index} {...experience} />;
                        })}
                    </div>
                    <div className="wrapper">
                        <div className="experience-image">
                          <img src={experience} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
